import React, { useState } from "react";
import { ArrowLeft, Check, Info } from "react-feather";
import { Button, Card, CardBody } from "reactstrap";
import { availableSubscriptionPlans } from "../../../utils/constants";
import { toCamelCase } from "../../../utils/string";
import { SparkleIcon } from "../../../assets/icons";

interface IProps {
	subscriptionName: availableSubscriptionPlans;
	subscriptionPrice?: number;
	subscriptionDescription: string;
	subscriptionInterval: string;
	subscriptionDetails: string[];
	dividerColor?: string;
	handleSelectPlan?: (plan: availableSubscriptionPlans) => void;
	isPopular?: boolean;
	isSelected?: boolean;
}

const SubscriptionCard: React.FC<IProps> = ({
	subscriptionName,
	subscriptionPrice,
	subscriptionInterval,
	subscriptionDescription,
	subscriptionDetails,
	dividerColor,
	handleSelectPlan,
	isPopular,
	isSelected,
	...props
}) => {
	const [viewDetails, setViewDetails] = useState<boolean>();

	return (
		<Card className={`subscription-card ${isPopular ? 'popular' : ''} ${isSelected ? 'selected' : ''}`}>
			{isPopular && (
				<div className="popular-badge">
					<span className="badge-text">Most</span>
					<span className="badge-text">Popular</span>
				</div>
			)}
			<CardBody>
				<div className={"option"}>
					<h4>{toCamelCase(subscriptionName)}</h4>
					{!viewDetails ? (
						<>
							<p className="price">
								{subscriptionPrice && subscriptionInterval ? (
									<>
										<span className="price-amount">${subscriptionPrice}</span>
										<span className="price-interval">/{subscriptionInterval}</span>
									</>
								) : (
									"Custom"
								)}
							</p>
							<hr style={{ borderTop: `3px solid ${dividerColor || "#3f65f1"}`, width: "100%" }} />
							<p className="description">
								{subscriptionDescription}
							</p>
							<ul className="feature-list">
								{subscriptionDetails.slice(0, 3).map((detail: string, index: number) => {
									return (
										<li key={index}>
											<Check size={16} />
											<span>{detail}</span>
										</li>
									);
								})}
							</ul>
						</>
					) : (
						<>
							<ul>
								{subscriptionDetails.map((detail: string, index: number) => {
									return (
										<li key={index}>
											<Check size={16} />
											<span>{detail}</span>
										</li>
									);
								})}
							</ul>
						</>
					)}
					<a
						href={`${subscriptionName == "supplier" ? "#supplier-features" : "#features"}`}
						style={{ textDecoration: "none", color: "inherit" }}
					>
						<span className="info">
							<Info size={18} />
							View Details
						</span>
					</a>
					{handleSelectPlan ? (
						<>
							<Button
								className="btn-outline-primary"
								onClick={() => handleSelectPlan(subscriptionName)}
							>
								Choose plan
							</Button>
							{subscriptionName !== availableSubscriptionPlans.supplier &&
							 subscriptionName !== availableSubscriptionPlans.enterprise &&
							 subscriptionName !== availableSubscriptionPlans.guava && (
								<p className="free-trial-text">
									<SparkleIcon size={16} color="#10b981" />
									Start 14-day free trial
								</p>
							)}
						</>
					) : (
						<a
							href={`mailto:sales@journeyfoods.com?subject=${toCamelCase(
								subscriptionName
							)} Tier Subscription Inquiry`}
						>
							<Button className="btn-outline-primary">Contact us</Button>
						</a>
					)}
				</div>
			</CardBody>
		</Card>
	);
};

export default SubscriptionCard;
